import { useTranslation } from 'react-i18next';
import { SupportEmailRequestCategory } from '../types/support-email-request.types';

type Props = { category: SupportEmailRequestCategory };

const SupportEmailRequestCategoryLabel = ({ category }: Props) => {
    const { t } = useTranslation();

    const key = (() => {
        switch (category) {
            case SupportEmailRequestCategory.Support:
                return 'supportEmailRequests.category.support';
            case SupportEmailRequestCategory.Privacy:
                return 'supportEmailRequests.category.privacy';
            case SupportEmailRequestCategory.General:
                return 'supportEmailRequests.category.general';
            default:
                return 'supportEmailRequests.category.unknown';
        }
    })();

    return <span className="text-sm text-black">{t(key)}</span>;
};

export default SupportEmailRequestCategoryLabel;
